import { useSeo } from "@/lib/seo";
import { Section } from "@/components/common/Section";
import { LinkButton } from "@/components/common/LinkButton";

export default function NotFound() {
  useSeo({ title: "Page Not Found | Legacy Spa", path: "/404" });
  return (
    <Section className="bg-legacy-charcoal min-h-[70vh] flex items-center">
      <div className="text-center mx-auto max-w-xl">
        <p className="font-heading text-8xl md:text-9xl text-legacy-mint/30">404</p>
        <h1 className="mt-4 font-heading text-4xl md:text-5xl text-white">
          This page took a break.
        </h1>
        <p className="mt-4 text-white/60">
          The page you're looking for can't be found. Let's get you back to
          wellness.
        </p>
        <div className="mt-8 flex justify-center">
          <LinkButton to="/" testId="notfound-home-btn">
            Back to Home
          </LinkButton>
        </div>
      </div>
    </Section>
  );
}
